import { LOCALE_STORAGE_KEY } from "./appLocale";
import { unref } from "vue";
import type { VueI18nInstance } from "vue-i18n";

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.$i18n as VueI18nInstance;

  let persistedLocale: "en" | "sv" | null = null;
  if (typeof window !== "undefined" && window.localStorage) {
    persistedLocale = window.localStorage.getItem(LOCALE_STORAGE_KEY) as "en" | "sv" | null;
  }

  const availableLocales: ("en" | "sv")[] = Array.isArray(i18n?.availableLocales)
    ? i18n.availableLocales
    : [];

  const rawLocale = i18n ? unref(i18n.locale) : null;
  const defaultLocale: "en" | "sv" =
    (typeof rawLocale === "string" && rawLocale) || "en";

  const localeToUse: "en" | "sv" =
    persistedLocale && availableLocales.includes(persistedLocale)
      ? persistedLocale
      : defaultLocale;

  i18n.setLocale(localeToUse);
});
